import { defineMessages } from "react-intl";

import {
	resultMessages,
	validator
} from "lib/build/forms/ktx/transplantation-screening/imaging-procedures/carotisDoppler";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	carotisDoppler: {
		id: "ktx.carotisDoppler.title",
		defaultMessage: "Nyaki ultrahang (Carotis Doppler)"
	},
	result: {
		id: "ktx.carotisDoppler.field.result",
		defaultMessage:
			"Eredmény (Kérjük 50 éves kor feletti páciens vagy 10+ év dialízis kezelés esetén mindenképpen töltse ki az űrlapot)"
	},
	comment: {
		id: "ktx.carotisDoppler.field.comment",
		defaultMessage: "Megjegyzés"
	}
});

const fields: {
	[key: string]: FieldData;
} = {
	result: {
		type: "field",
		path: ["result"],
		label: messages.result,
		errorMessages: genericErrorMessages,
		input: {
			type: "button-group",
			props: { labels: resultMessages }
		}
	},
	comment: {
		type: "field",
		path: ["comment"],
		label: messages.comment,
		errorMessages: genericErrorMessages,
		input: { type: "textarea", props: {} }
	}
};

const fieldset: FieldsetData = {
	rows: [
		{ columns: [{ width: 12, field: fields.result }] },
		{ columns: [{ width: 12, field: fields.comment }] }
	]
};

export const node: LeafNode = {
	id: "ktx_carotisDoppler",
	value: {
		schemaId: "carotisDoppler",
		title: messages.carotisDoppler,
		validator,
		fieldset,
		applyCurrentDate: false
	}
};
